document.addEventListener('DOMContentLoaded', function () {
    const components = document.querySelectorAll('.component-component-media');
    if (components.length === 0) return;

    const originalPositions = new WeakMap();

    components.forEach(component => {
        const mediaElement = component.querySelector('.component-component-media__media');
        if (mediaElement) {
            originalPositions.set(mediaElement, {
                parent: mediaElement.parentNode,
                nextSibling: mediaElement.nextSibling
            });
        }
    });

    function applyStyles() {
        if (window.innerWidth <= 767) return 0;

        let maxLeftOffset = 0;

        components.forEach(component => {
            const componentComponentMediaGrid  = component.querySelector('.component-component-media__grid');
            const componentComponentMediaLeft  = component.querySelectorAll('.component-component-media__media--left');
            const componentComponentMediaRight = component.querySelectorAll('.component-component-media__media--right');

            const container = component.closest('.block-container__content');

            if (container) {
                const containerRect = container.getBoundingClientRect();
                const distanceToLeft = containerRect.left;
                const distanceToRight = window.innerWidth - containerRect.right;

                maxLeftOffset = Math.max(maxLeftOffset, distanceToLeft); // track largest

                componentComponentMediaLeft.forEach(mediaElement => {
                    mediaElement.style.marginLeft = `-${distanceToLeft}px`;
                    mediaElement.style.width = `calc(100% + ${Math.abs(distanceToLeft)}px)`;
                });

                componentComponentMediaRight.forEach(mediaElement => {
                    mediaElement.style.width = `calc(100% + ${Math.abs(distanceToRight)}px)`;
                });
            }
        });

        return maxLeftOffset;
    }

    // Function to insert media element after heading on Mobile.
    function moveMediaDependingOnScreenSize() {
        components.forEach(component => {
            const mediaElement = component.querySelector('.component-component-media__media');
            if (!mediaElement) return;

            if (window.innerWidth >= 768) {
                const original = originalPositions.get(mediaElement);
                if (original && original.parent) {
                    original.parent.insertBefore(mediaElement, original.nextSibling);
                }
                return;
            }

            const imageBlock = component.querySelector('.wp-block-image');
            const headings = component.querySelectorAll('.wp-block-heading');

            // Remove media if it's no longer in this component
            if (mediaElement.parentNode !== component) {
                mediaElement.remove();
            }

            if (imageBlock && imageBlock.parentNode) {
                imageBlock.parentNode.insertBefore(mediaElement, imageBlock);
            } else {
                let inserted = false;

                headings.forEach(heading => {
                    // Skip H6 subheadings
                    if (heading.tagName.toLowerCase() === 'h6') return;

                    const nextElem = heading.nextElementSibling;
                    // Skip if next sibling is also a heading (any level)
                    if (nextElem && /^h[1-6]$/i.test(nextElem.tagName)) return;

                    // Insert after this heading
                    heading.parentNode.insertBefore(mediaElement, heading.nextSibling);
                    inserted = true;
                    return;
                });

                // If no suitable heading was found, insert at top
                if (!inserted) {
                    component.insertBefore(mediaElement, component.firstChild);
                }
            }
        });
    }

    applyStyles();
    moveMediaDependingOnScreenSize();

    window.addEventListener('resize', () => {
        applyStyles();
        moveMediaDependingOnScreenSize();
    });
});